import { useFocused, useSelected, useSlateStatic } from 'slate-react';

import unlink from '../../Toolbar/toolbarIcons/unlink.svg';
import { removeLink } from '../../utils/link.js';
import './styles.css';
const Link = ({ attributes, element, children }) => {
  const editor = useSlateStatic();
  const selected = useSelected();
  const focused = useFocused();
  return (
    <div className='TclinkComponent'>
      <a href={element.href} {...attributes} {...element.attr} target={element.target}>
        {children}
      </a>
      {selected && focused && (
        <div className='TclinkComponent-popup' contentEditable={false}>
          <a href={element.href} target={element.target}>
            {element.href}
          </a>
          <button onClick={() => removeLink(editor)}>
            <img src={unlink} alt='' />
          </button>
        </div>
      )}
    </div>
  );
};

export default Link;
